<template>
    <v-footer
            color="dark-color darken-2"
            padless
    >
        <v-row
                justify="center"
                no-gutters
        >
            <v-col class="py-4 text-center white--text d-flex align-center justify-center" cols="8">
                <span>{{ new Date().getFullYear() }} — <strong>Gadget cloud</strong></span>
            </v-col>
            <v-col cols="4">
                <v-app-bar dark color="transparent" elevation="0">
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <contact-component></contact-component>
                    </v-toolbar-items>
                </v-app-bar>
            </v-col>
        </v-row>
    </v-footer>
</template>
<script>
    import ContactComponent from '../../components/contact-dialog';
    export default {
        components:{ContactComponent},
        data(){
            return{
                activeBtn: 2
            }
        }
    }
</script>
